<div *ngIf="!isIconImage" class="c-avatar__initials">
    {{ initials }}
</div>
<img *ngIf="isIconImage && user && user[imgField]?.length"
    class="c-avatar__img"
    [src]="user[imgField]" />
